import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


import LoginForm from './components/LoginForm';
import TrustIndicators from './components/TrustIndicators';
import SuccessStories from './components/SuccessStories';
import QuickAccessLinks from './components/QuickAccessLinks';
import PlatformBenefits from './components/PlatformBenefits';
import MainNavigation from '../../components/ui/MainNavigation';

const CustomerLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (formData) => {
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Redirect to homepage after successful login
      navigate('/homepage');
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Navigation */}
      <MainNavigation />

      {/* Main Content */}
      <main className="flex-1 py-8 sm:py-12 pt-16 lg:pt-8 lg:ml-[72px] transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Mobile Layout */}
          <div className="lg:hidden">
            <div className="space-y-6 sm:space-y-8">
              {/* Login Form */}
              <div className="px-2 sm:px-4">
                <LoginForm onSubmit={handleLogin} isLoading={isLoading} />
              </div>

              {/* Trust Indicators */}
              <div className="px-2 sm:px-4">
                <TrustIndicators />
              </div>

              {/* Success Stories */}
              <div className="px-2 sm:px-4">
                <SuccessStories />
              </div>

              {/* Quick Access Links */}
              <div className="px-2 sm:px-4">
                <QuickAccessLinks />
              </div>
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden lg:block">
            <div className="grid grid-cols-12 gap-8">
              {/* Left Column - Login Form */}
              <div className="col-span-5">
                <div className="sticky top-24 space-y-6">
                  <LoginForm onSubmit={handleLogin} isLoading={isLoading} />
                  <TrustIndicators />
                </div>
              </div>

              {/* Right Column - Benefits & Information */}
              <div className="col-span-7">
                <div className="space-y-8">
                  {/* Platform Benefits */}
                  <PlatformBenefits />

                  {/* Success Stories */}
                  <SuccessStories />

                  {/* Quick Access Links */}
                  <QuickAccessLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-card border-t border-border py-6 sm:py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm font-body text-muted-foreground">
              © {new Date()?.getFullYear()} Verduurzaamwijzer. Alle rechten voorbehouden.
            </p>
            <div className="mt-2 flex items-center justify-center space-x-4 text-xs font-caption text-muted-foreground">
              <span>🇳🇱 Gemaakt in Nederland</span>
              <span>•</span>
              <span>GDPR Compliant</span>
              <span>•</span>
              <span>KvK: 12345678</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CustomerLogin;